<template>
  <v-page-content>
    <b-card class="my-2 w-100">
      <div class="d-flex">
        <div>
          <h5>{{ currentProfession.title }}</h5>
          <a
            class="prof-organization"
            :href="
              currentProfession.organization.siteUrl
                ? currentProfession.organization.siteUrl
                : '/page_not_exist'
            "
            target="_blank"
            >{{ currentProfession.organization.title }}</a
          >
        </div>
        <b-button
          variant="primary"
          class="d-block ml-auto h-50"
          @click="onEditClick"
          v-if="canEdit()"
        >
          Изменить
        </b-button>
        <b-button
          variant="primary"
          class="d-block ml-auto h-50"
          @click="markProfession"
          v-else-if="!isMarked && hasRole('student')"
        >
          В избранное
        </b-button>
        <b-button
          variant="success"
          class="d-block ml-auto h-50"
          @click="unmarkProfession"
          v-else-if="isMarked && hasRole('student')"
        >
          В избранном
        </b-button>
      </div>
      <router-link
        :to="{
          path: `/administration/recommendation/professions-interested`,
          query: {
            orgId: currentProfession.organization.id,
            profId: currentProfession.id,
          },
        }"
        v-if="userHasRole('curator') && userHasRole('admin')"
        >Список заинтересованных</router-link
      >
      <h5><b>Описание</b></h5>
      <div class="ml-1">
        <p style="white-space: pre-line">
          <span>{{ currentProfession.data.description }}</span>
        </p>
      </div>
      <div v-if="currentProfession.data.conditions">
        <h5><b>Условия работы</b></h5>
        <div class="ml-1">
          <p style="white-space: pre-line">
            <span>{{ currentProfession.data.conditions }}</span>
          </p>
        </div>
      </div>
      <div v-if="currentProfession.data.requirements">
        <h5><b>Задачи</b></h5>
        <div class="ml-1">
          <p style="white-space: pre-line">
            <span>{{ currentProfession.data.requirements }}</span>
          </p>
        </div>
      </div>
      <div v-if="currentProfession.data.requirementsForApplicant">
        <h5><b>Требования к кандидату</b></h5>
        <div class="ml-1">
          <p style="white-space: pre-line">
            <span>{{ currentProfession.data.requirementsForApplicant }}</span>
          </p>
        </div>
      </div>
      <div class="carousel-container-gathering mb-2">
        <b-carousel
          :interval="4000"
          controls
          indicators
          background="#e4dede"
          class="carousel-container-g"
        >
          <b-carousel-slide
            v-for="(src, index) in getFileSrc('img')"
            class="carousel-slide-container"
            :key="index"
          >
            <template #img>
              <div class="d-flex text-center h-100">
                <img
                  :src="`/api/files/${src}`"
                  class="w-100 my-auto"
                  style="object-fit: cover; height: 500px"
                />
              </div>
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>
      <div class="carousel-container-gathering">
        <div
          class="carousel-container-g"
          v-for="(src, index) in getFileSrc('video')"
          :key="index"
        >
          <iframe
            style="width: 100%; height: 500px"
            v-if="isUrlYoutube(src)"
            :src="`https://www.youtube.com/embed/${getIdFromYoutubeUrl(src)}`"
          >
          </iframe>
          
          <iframe
            style="width: 100%; height: 500px"
            v-else-if="isUrlRutube(src)"
            :src="`https://rutube.ru/play/embed/${src.split('/').at(-2)}`"
          >
          </iframe>
          <video
            class="w-100 prof-image rounded-lg"
            controls
            style="height: 500px"
            v-else
          >
            <source :src="src" />
          </video>
          
        </div>
      </div>

      <div class="text-right" v-if="filesGroup.pdf">
        <div class="display-inline">
          <a
            :href="`/api/files/${getFileSrc('pdf')}`"
            :download="getFileName('pdf')"
          >
            Скачать презентацию
          </a>
          <em class="fas fa-file-pdf" style="color: #017ac3"></em>
        </div>
      </div>
      <h5>Направления для обучения по профессии</h5>
      <div v-if="currentProfession.educationDirections.length === 0">
        <h6>Направления для обучения отсутствуют</h6>
      </div>
      <div
        v-for="(direction, index) of currentProfession.educationDirections"
        :key="index"
      >
        <b-card class="university-item">
          <h5>{{ getDirectionTitle(direction) }}</h5>
          <div v-if="directionsLoaded">
            <div v-if="!currentDirections[direction.id]">
              <h6>Рекомендованные вузы отсутствуют</h6>
            </div>
            <div
              class="d-flex justify-content-between"
              v-for="(u, index) of currentDirections[direction.id]"
              :key="index"
            >
              <router-link
                :to="{
                  path: `/profession/${currentProfession.id}/direction`,
                  query: { orgId: u.organization.id, eduCode: direction.code },
                }"
                >{{ u.organization.title }}</router-link
              >
            </div>
          </div>
          <div v-else>
            <b-alert variant="light" show class="mt-3">
              <div class="text-center">
                <b-spinner variant="primary" />
              </div>
            </b-alert>
          </div>
        </b-card>
      </div>
    </b-card>
    <EditProfessionModal
      v-if="professionLoaded"
      :editData="currentProfession"
      @save="onSaveProfession"
      :isEdit="true"
    />
  </v-page-content>
</template>
    
<script>
import EditProfessionModal from '@/components/admin/modals/recommendations/EditProfessionModal.vue'
import RecommendationAPI from '@/api/recommendation'
import OrganizationAPI from '@/api/organization'
import { uploadFormDataFiles } from '../../helpers/professions'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ProfessionsView',
  components: {
    EditProfessionModal,
  },
  data() {
    return {
      editData: null,
      currRole: 'student',
      currentProfession: {
        citizenship: '',
        description: '',
        educationDirections: {},
        data: {},
        files: [],
        gender: '',
        id: null,
        organization: {},
        organizationId: {},
        title: '',
        updaterId: null,
        requirements: null,
      },
      currentOrganization: {},
      currentDirections: {},
      filesGroup: { img: null, video: null, pdf: null },
      directionsLoaded: false,
      professionLoaded: false,
      currProfessionFiles: {},
      isMarked: false,
    }
  },
  async created() {
    await this.getCurrentProfession()
    this.currentOrganization = (
      await OrganizationAPI.getOrganizationById(this.currUser.organizationId)
    ).data
    this.groupFiles()
    this.getDirections()
    await this.isProfessionMarked()
  },
  computed: {
    ...mapGetters({
      currUser: 'currentUser/getCurrentUser',
      hasRole: 'currentUser/hasRole',
      getStoredDirections: 'profession/getDirections',
    }),
  },
  methods: {
    ...mapActions({
      setStoredDirections: 'profession/fetchDirections',
      setProfessionsList: 'profession/fetchProfessions',
    }),
    async getMarkedProfessions() {
      this.markedProfessions = (
        await RecommendationAPI.getMarkedProfessionsByUser()
      ).data
    },
    async markProfession() {
      await RecommendationAPI.markProfession(this.currentProfession.id)

      this.isMarked = true
    },
    async unmarkProfession() {
      await RecommendationAPI.unmarkProfession(this.currentProfession.id)
      this.isMarked = false
    },
    async isProfessionMarked() {
      const isMarked = (
        await RecommendationAPI.isProfessionMarked(this.currentProfession.id)
      ).data
      if (isMarked) this.isMarked = true
      else this.isMarked = false
    },
    canEdit() {
      if (this.hasRole('admin')) return true
      if (
        (this.hasRole('admin') || this.hasRole('curator')) &&
        this.currentOrganization.id === this.currentProfession.organizationId
      )
        return true
      return false
    },
    async getCurrentProfession() {
      this.currentProfession = (
        await RecommendationAPI.getProfession(this.$route.params.id)
      ).data.professions
      this.professionLoaded = true
    },
    getDirectionTitle(value) {
      return `${value.code} ${value.title}`
    },
    addDirectionCodeTitle() {
      if (this.currentProfession) {
        for (const d of this.currentProfession.educationDirections) {
          d.codeTitle = this.getDirectionTitle(d)
        }
      }
    },
    onEditClick() {
      this.addDirectionCodeTitle()

      this.$bvModal.show('editProfessionModal')
    },
    userHasRole(role) {
      return this.$store.getters['currentUser/hasRole'](role)
    },
    groupFiles() {
      this.filesGroup = _.groupBy(this.currentProfession.files, 'type')
    },
    getFileSrc(type) {
      if (
        type === 'video' &&
        this.currentProfession.data &&
        this.currentProfession.data.videosUrls
      ) {
        return this.currentProfession.data.videosUrls
      } else {
        return this.filesGroup[type]
          ? this.filesGroup[type].map((d) => d.physicalName)
          : []
      }
    },
    getFileName(type) {
      if (this.filesGroup[type]) {
        return this.filesGroup[type][0].name
      } else return ''
    },
    isArrayEqual(x, y) {
      return _(x).differenceWith(y, _.isEqual).isEmpty()
    },
    isUrlYoutube(url) {
      return /^(https?:\/\/)?(www\.)?(youtube\.com)/.test(url)
    },
    isUrlRutube(url) {
      return /^(https?:\/\/)?(www\.)?(rutube\.ru)/.test(url)
    },
    getIdFromYoutubeUrl(url) {
      let regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
      let match = url.match(regExp)
      return match && match[7].length == 11 ? match[7] : false
    },
    async getDirections() {
      if (
        this.$store.state.profession.directions === null ||
        this.isArrayEqual(
          this.$store.state.profession.directions,
          this.directions
        )
      ) {
        await this.setStoredDirections()
      }
      let directions = this.getStoredDirections
      const professionDirections = Object.keys(
        _.groupBy(this.currentProfession.educationDirections, 'id')
      )
      const universitiesToShowIds =
        this.currentProfession.universitiesToShow.map((d) => d.id)
      directions = _.filter(directions, (r) => {
        return universitiesToShowIds.includes(r.organization.id)
      })
      this.currentDirections = _.groupBy(
        directions.filter((d) =>
          professionDirections.includes(String(d.educationDirection.id))
        ),
        'educationDirection.id'
      )
      for (const dir of Object.keys(this.currentDirections)) {
        this.currentDirections[dir] = _.uniqBy(
          this.currentDirections[dir],
          'organization.id'
        )
        this.currentDirections[dir] = _.sortBy(
          this.currentDirections[dir],
          (d) => {
            const found = _.find(
              this.currentProfession.universitiesToShow,
              (r) => {
                return r.id === d.organization.id
              }
            )
            return found.professionOrgsToShow.index
          }
        )
      }
      this.directionsLoaded = true
    },
    async onSaveProfession(data) {
      const uploadedData = await uploadFormDataFiles(data)
      const addedFiles = uploadedData.addedFiles
      const directionsId = uploadedData.directionsId
      data.addedFiles = addedFiles
      data.directionsId = directionsId
      data.organizationId = data.organization.id
      if (this.currentProfession) await RecommendationAPI.editProfession(data)
      else await RecommendationAPI.addProfession(data)
      await this.setProfessionsList()
      await this.getCurrentProfession()
      this.groupFiles()
      this.getDirections()
    },
  },
}
</script>
    
<style scoped>
.prof-organization {
  color: gray;
}
.prof-image {
  object-fit: cover;
  width: 100%;
}
.university-item {
  margin-bottom: 1rem;
}
.university-organization {
  color: gray;
}
.carousel-container-gathering {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.carousel-container-g {
  width: 60%;
  max-width: 920px;
}

@media screen and (max-width: 1400px) {
  .carousel-container-g {
    width: 100%;
  }
}
</style>
    